'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Contact', href: '/contact' },
    { label: 'Pricing', href: '/pricing' },
  ];

  const isFAQPage = pathname === '/faq';

  return (
    <nav
      className={`navbar-wrapper ${
        isFAQPage ? 'navbar-faq' : ''
      } ${isScrolled ? 'scrolled' : ''}`}
    >
      <div className="navbar-container">

        {/* Logo */}
        <Link href="/" className="navbar-logo">
          <Image
            src="/images/AVE-Payroll.png"
            alt="AVE - Payroll"
            width={210}
            height={60}
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar-links-desktop">
          {navLinks.map((item) => (
            <Link
              key={item.label}
              href={item.href}
              className="navbar-link"
            >
              {item.label}

              <span className="underline-effect" />
            </Link>
          ))}
        </div>

        {/* Desktop Actions */}
        <div className="navbar-actions-desktop">
          <Link
            href="/auth/register"
            className="navbar-btn-register"
          >
            Register
          </Link>

          <Link
            href="/auth/login"
            className="navbar-btn-login"
          >
            Login
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="navbar-mobile-toggle"
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
        >
          {isOpen ? (
            <X size={28} />
          ) : (
            <Menu size={28} />
          )}
        </button>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="navbar-mobile-menu">

            {navLinks.map((item) => (
              <Link
                key={item.label}
                href={item.href}
                className="navbar-mobile-link"
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </Link>
            ))}

            <div className="navbar-mobile-actions">

              <Link
                href="/auth/register"
                className="navbar-mobile-btn-register"
                onClick={() => setIsOpen(false)}
              >
                Register
              </Link>

              <Link
                href="/auth/login"
                className="navbar-mobile-btn-login"
                onClick={() => setIsOpen(false)}
              >
                Login
              </Link>

            </div>
          </div>
        )}
      </div>
    </nav>
  );
}